import { instance, objectToParams } from './api';

/**
 * GET /api/v1/deposits/losses
 *
 * Sin `depositId` la consulta es cross-deposit. Con `depositId` se restringe
 * a ese depósito. Acepta los mismos filtros plurales que el listado de stock.
 */
export const getLosses = (args) => instance.get(`/api/v1/deposits/losses?${objectToParams(args)}`);

/**
 * POST /api/v1/deposits/losses/auto-reconcile
 *
 * Cuadra de una vez todos los grupos que se compensan solos y pasan los filtros que se
 * le manden (los mismos del listado). `netZero` decide qué se considera un grupo:
 * `family` para el cambio de talla, `serie` para el cambio de color entre hermanas.
 * Con `dryRun` devuelve lo que haría sin escribir.
 */
export const postAutoReconcileLosses = (args) =>
  instance.post(`/api/v1/deposits/losses/auto-reconcile?${objectToParams(args)}`);
